<template>
    <div class="anthropometrics-edit-modal">

        <!-- edit button -->
        <b-btn size="sm" class="btn-edit btn-icon" variant="default"
               @click.stop="showModal()">
            <shs-icon name="plus"></shs-icon>
        </b-btn>

        <!-- modal -->
        <data-form-modal :modal-id="modalId"
                         :title="$i18n.gt('LABEL_EDIT_ANTHROPOMETRICS')"
                         :size="$mq == 'sm' ? 'sm' : 'md'"
                         :horizontal="$mq != 'sm'"
                         :save-button-label="$i18n.gt('LABEL_SAVE')"
                         :field-model="anthropometricsFields"
                         :field-groups="fieldGroups"
                         :model-instance="editingAnthropometrics"
                         :on-cancel-handler="cancelModal"
                         :on-submit-handler="save">
        </data-form-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import AnthropometricsFields from '@/models/Anthropometrics'

    /**
     * Button and modal to edit an individual Anthropometrics record
     */

    export default Vue.extend({
        name: 'AnthropometricsEditModal',
        props: {
            participantId: Number,
        },
        data() {
            return {
                editingAnthropometrics: {
                    participant_id: this.participantId,
                    practice_id: this.$store.state.currentUser.practitionerPracticeId
                },
                anthropometricsFields: AnthropometricsFields,
                fieldGroups: [
                    ['weight_lb', 'height_in', 'waist_in', 'bp_systolic', 'bp_diastolic', 'comment']
                ],
            }
        },
        computed: {
            modalId() {
                return `anthropometricsModal`
            }
        },
        methods: {
            showModal() {
                this.$bvModal.show(this.modalId)
            },
            cancelModal() {
                this.$bvModal.hide(this.modalId)
            },
            async save() {
                await this.$api.createItem(this, 'anthropometrics', this.editingAnthropometrics, true)
                this.refresh()
            },
            refresh() {
                this.$store.dispatch('getPatientParticipant',
                    {
                        participantId: this.editingAnthropometrics.participant_id,
                        force: true
                    })
            }
        },
    })
</script>
